import { createPathSelector } from "../../actions/requestDefaults";
import { EcsActionType } from "../actions";
function compareByPath(a, b) {
    return a.path < b.path ? -1 : b.path < a.path ? 1 : 0;
}
const initialState = {
    selectors: [],
    defaults: createPathSelector("/"),
    subscribers: {},
};
function removeEmptySubscribers(subscribers) {
    return Object.entries(subscribers).reduce((acc, [path, ids]) => (ids.length > 0 ? Object.assign(Object.assign({}, acc), { [path]: ids }) : acc), {});
}
export function selectorsReducer(state = initialState, action) {
    switch (action.type) {
        case EcsActionType.SetSelectors: {
            return Object.assign(Object.assign({}, state), { selectors: action.payload });
        }
        case EcsActionType.AddSelector: {
            const selector = action.payload;
            return Object.assign(Object.assign({}, state), { selectors: [...state.selectors, selector].sort(compareByPath) });
        }
        case EcsActionType.RemoveSelector: {
            const selector = action.payload;
            return Object.assign(Object.assign({}, state), { selectors: state.selectors
                    .filter((sel) => sel !== selector)
                    .sort(compareByPath) });
        }
        case EcsActionType.SetSelectorDefaults: {
            return Object.assign(Object.assign({}, state), { defaults: action.payload });
        }
        case EcsActionType.ResetAll:
            // only reset the selectors, else we lose settings
            return Object.assign(Object.assign({}, state), { selectors: initialState.selectors, subscribers: initialState.subscribers });
        case EcsActionType.AddSubscriber: {
            const { path, subscriberId } = action.payload;
            const subscribersIds = (state.subscribers[path] || []).filter((id) => id !== subscriberId);
            return Object.assign(Object.assign({}, state), { subscribers: removeEmptySubscribers(Object.assign(Object.assign({}, state.subscribers), { [path]: [...subscribersIds, subscriberId] })) });
        }
        case EcsActionType.RemoveSubscriber: {
            const { path, subscriberId } = action.payload;
            const subscribersIds = (state.subscribers[path] || []).filter((id) => id !== subscriberId);
            return Object.assign(Object.assign({}, state), { subscribers: removeEmptySubscribers(Object.assign(Object.assign({}, state.subscribers), { [path]: subscribersIds })) });
        }
        default:
            return state;
    }
}
//# sourceMappingURL=selectorsReducer.js.map